import { useState } from 'react';
import { parseData } from '../util/data';
import { apiClient } from '../util/http';

export const create = async (payload) => {
  const { data } = await apiClient.post(`/payroll-parameter`, payload);
  return parseData(data);
};

export const update = async (id, payload) => {
  const { data } = await apiClient.put(`/payroll-parameter/${id}`, payload);
  return parseData(data);
};

export const findById = async (id) => {
  const { data } = await apiClient.get(`/payroll-parameter/${id}`);
  return parseData(data);
};

export const useSalvarParametrizacao = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const salvarParametrizacao = async (parametrizacao) => {
    try {
      setLoading(true);

      await create(parametrizacao);
      setSuccess(true);
      setError(undefined);
    } catch (e) {
      let msg = 'Algo de errado aconteceu, por favor tente novamente.';

      if (e.response && e.response.data && e.response.data.status === 400) {
        msg = e.response.data.message;
      }

      if (process.env.development) {
        msg = e.stack;
      }
      setError(msg);
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  return {
    salvarParametrizacao,
    loading,
    error,
    success,
  };
};
